<template>
    <main class="report">
        <Consultation key="Consultation"/>
    </main>
</template>

<script>
import Consultation from "@/components/report/Consultation"

export default {
    name: "EditReport",
    components: {
        Consultation
    }
};
</script>

<style lang="scss">
.report {
    flex: 1;

    &__title {
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 1.6px;
        color: #4A4949;
    }
}
</style>
